<template>
  <v-container
    id="usersList"
    fluid
    tag="section"
    class="full-height"
  >
    <base-v-component
      heading="Потребители"
    />

    <v-row class="mt-10 d-print-none">
      <v-col cols="12" class="text-right">
        <v-btn
          class="primary px-5"
          @click="newUser"
        >
          <v-icon
            left
            dark
          >
            mdi-plus
          </v-icon>
          Нов потребител
        </v-btn>
      </v-col>
    </v-row>

    <filter-users 
      ref="filterUsers"
      @doFilter="getData"
    />

    <base-material-card
      color="primary"
      icon="mdi-gesture-double-tap"
      inline
      class="px-5 py-3 mt-15"
    >
    
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light"></div>
      </template>

      <v-divider class="mt-3 mb-6" />

      <base-data-table 
        ref="tableUsers"
        :headers="table.headers" 
        :pagination="table.pagination" 
        :data="table.data" 
        :sortBy.sync="table.sortBy"
        :sortDesc.sync="table.sortDesc" 
        @getData="getData" 
        @doAction="doAction"
      />
    </base-material-card>
  </v-container>
</template>

<script>
import { filterUsers } from '@/components';
import { getUsersList } from '@/api/users';

export default {
  name: 'UsersList',
  components: {
    filterUsers,
  },
  data: () => ({
    table: {
      headers: [
        { text: 'Име', value: ['firstName', 'lastName'], valueType: 'moreThanOneField'},
        { text: 'E-mail', value: 'email', valueType: 'text'},
        { text: 'Телефон', value: 'phone', valueType: 'text'},
        { text: 'Права', value: 'access', valueType: 'translateValue', translateValues: [{label: 'Администратор', value: 0}, {label: 'Потребител', value: 1}]},
        { text: 'Статус', value: 'status', valueType: "status", active: 1, notActive: 0, statusIcons: true, activeClass: 'fw600 success--text', notActiveClass: 'fw600 error--text' },
        {
          sortable: false,
          text: '',
          value: '',
          valueType: 'button',
          style: 'width: 150px;',
          class: 'text-right',
          buttons: [
            {
              label: 'Преглед',
              title: 'Преглед',
              icon: 'mdi-text-box-search-outline',
              size: 'small',
              class: 'primary',
              click: 'previewUser',
            }
          ]
        },
      ],
      data: [],
      sortBy: 'firstName',
      sortDesc: true,
      pagination: {
        itemsPerPage: 10,
        page: 1,
        perPageOptions: [5, 10, 25, 50, 100],
        total: 0
      }
    }
  }),
  mounted(){
    this.getData();
  },
  methods: {
    getData(){
      let query = Object.assign({}, this.$refs.filterUsers.filters);
      if(!query.page) query.page = this.table.pagination.page;
      query.itemsPerPage = this.table.pagination.itemsPerPage;
      query.sortBy = this.table.sortBy;
      query.sortDesc = this.table.sortDesc;
      getUsersList(query).then(data => {
        this.table.data = data.Items;
        this.table.pagination.total = data.Total;
        this.table.pagination.page = query.page;
      })
    },
    doAction(data){
      switch(data.action){
        case 'previewUser':
          this.$router.push({path: `/admin/users/${data.item._id}`})
        break;
      }
    },
    newUser(){
      this.$router.push({path: '/admin/users/create'})
    }
  }
}
</script>
